import {provideTranslateService} from '@ngx-translate/core'
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader'
import {version} from 'package.json'

export const provideTranslateConfig = () =>
  provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: `.json?v=${version}`
    })
  })
